// src/constants/platformRoles.js

/*
 * ShiftBridge Platform Role Compatibility Layer
 *
 * IMPORTANT:
 * The canonical application-side role authority lives at:
 *
 *   src/security/permissions.js
 *
 * Older modules may continue importing role constants/helpers
 * from src/constants/platformRoles.js during migration.
 *
 * DO NOT define a second role normalization or authorization
 * system in this file.
 */

import {
  PLATFORM_ROLES,
  normalizePlatformRole,
  getUserRole,
  isPlatformAdmin as canonicalIsPlatformAdmin,
  isFacilityPlanner as canonicalIsFacilityPlanner,
  isFacilityClient as canonicalIsFacilityClient,
  isWorker as canonicalIsWorker,
} from "../security/permissions";

/* =========================================================
   CANONICAL ROLE CONSTANTS
   ========================================================= */

export {
  PLATFORM_ROLES,
};


/* =========================================================
   LEGACY ADMIN ROLE LIST
   =========================================================
 *
 * Retained only for compatibility with older imports.
 *
 * New authorization code should use:
 *
 *   isPlatformAdmin(profile)
 *
 * from src/security/permissions.js.
 */

export const ADMIN_ROLES =
  Object.freeze([
    PLATFORM_ROLES.OWNER_ADMIN,
    PLATFORM_ROLES.FINANCE_ADMIN,
    PLATFORM_ROLES.OPERATIONS_ADMIN,
    PLATFORM_ROLES.AGENCY_ADMIN,
  ]);


/* =========================================================
   LEGACY STRING-ROLE ADAPTER
   ========================================================= */

function legacyRoleProfile(
  platformRole
) {
  const normalizedRole =
    normalizePlatformRole(
      platformRole
    );

  return {
    role: normalizedRole,
    platformRole: normalizedRole,
  };
}


/* =========================================================
   LEGACY API COMPATIBILITY
   ========================================================= */

export function isPlatformAdmin(
  platformRole
) {
  return canonicalIsPlatformAdmin(
    legacyRoleProfile(
      platformRole
    )
  );
}


export function isFacilityPlanner(
  platformRole
) {
  return canonicalIsFacilityPlanner(
    legacyRoleProfile(
      platformRole
    )
  );
}


export function isFacilityAdminViewer(
  platformRole
) {
  return (
    getUserRole(
      legacyRoleProfile(
        platformRole
      )
    ) ===
    PLATFORM_ROLES.FACILITY_ADMIN_VIEWER
  );
}


export function isFacilityClient(
  platformRole
) {
  return canonicalIsFacilityClient(
    legacyRoleProfile(
      platformRole
    )
  );
}


export function isWorker(
  platformRole
) {
  return canonicalIsWorker(
    legacyRoleProfile(
      platformRole
    )
  );
}